export default __webpack_public_path__ + "static/lutein-restartirat-zrenieto-mobile-db0fcac08b34e6898e992af825ee60c5.jpg";